
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"20","fill":"#BBF7D0"}}),_c('g',{attrs:{"clip-path":"url(#clip0_11338_7065)"}},[_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"12","y":"14","width":"16","height":"11"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M27.256 14.41a.833.833 0 010 1.18l-9.167 9.166a.834.834 0 01-1.178 0l-4.167-4.167a.833.833 0 111.179-1.178l3.577 3.577 8.577-8.577a.833.833 0 011.179 0z","fill":"#061938"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"fill":"#182230","d":"M10 10h20v20H10z"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_11338_7065"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(10 10)","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    